import React, { useContext, useEffect, useState } from 'react'
import FullCalendar from '@fullcalendar/react'
import moment, { Moment } from 'moment'
import momentPlugin from '@fullcalendar/moment'
import momentTimezonePlugin from '@fullcalendar/moment-timezone'
import timeGridPlugin from '@fullcalendar/timegrid'
// import interactionPlugin from '@fullcalendar/interaction' // needed for dateClick
// import Container from 'presentation/hospital/components/Container'
import { ReactComponent as PreparationImage } from 'presentation/assets/scheduling-sector/preparation.svg'
import { ReactComponent as ReserveImage } from 'presentation/assets/scheduling-sector/reserve.svg'
import { ReactComponent as InterdictedImage } from 'presentation/assets/scheduling-sector/interdicted.svg'
// import { ReactComponent as MaximizeIcon } from 'presentation/assets/icons/maximize.svg'
import CardNew from 'presentation/shared/components/CardNew'

import * as S from './styles'
import { TimeStatus } from 'common/enum/time-status'
import Modal from 'presentation/shared/components/Modal'
import DividerNew from 'presentation/shared/components/DividerNew'
import { ReactComponent as CloseIcon } from 'presentation/assets/icons/close.svg'
import { useServices } from 'presentation/hooks/use-services'
import { toast } from 'react-toastify'
import LoadingModal from 'presentation/shared/components/LoadingModal'
import {
  DivergencyModal,
  FinishScheduleModal,
  UnavailableEquipmentModal
} from 'presentation/hospital/layouts/Home/SchedulingSector/components'
import {
  SurgicalSchedulingContext,
  SurgicalScheduleModelContext
} from 'presentation/hospital/layouts/Home/SchedulingSector/context'
import { AppointmentModel } from 'domain/entities/surgical-schedule-model'
import SupportTextNew from 'presentation/shared/components/SupportTextNew'
import SurgeryDetailsInfo from 'presentation/hospital/components/SurgeryDetailsInfo'

type ListRooms = {
  number: number
  dateReference: Date | Moment
  roomName: string
}

const PreparationContent = () => {
  return (
    <>
      <S.Subtitle>
        Tempo reservado para preparação e limpeza da sala.
      </S.Subtitle>
      <PreparationImage />
    </>
  )
}

const InterdictedContent = () => {
  return (
    <>
      <S.Subtitle>
        Esta sala está fechada ou interditada. Reserve outro horário ou sala.
      </S.Subtitle>
      <InterdictedImage />
    </>
  )
}

const ReservedContent = () => {
  return (
    <>
      <S.Subtitle>Esta sala já está reservada para um médico.</S.Subtitle>
      <ReserveImage />
    </>
  )
}

const ScheduledContent = ({ schedule }: any) => {
  return <SurgeryDetailsInfo surgicalSchedule={schedule} />
}

const RequestedContent = ({ schedule, isLoading }: any) => {
  return (
    <>
      <SurgeryDetailsInfo surgicalSchedule={schedule} />
      <LoadingModal show={isLoading} />
    </>
  )
}

const OpenSlotContent = ({ setShowModalEvent }: any) => {
  const [showFinishModal, setShowFinishModal] = useState(false)
  const [divergencyModal, setShowDivergencyModal] = useState(false)
  const [showUnavailableEquipmentModal, setShowUnavailableEquipmentModal] =
    useState(false)

  const [unavailableEquipments, setUnavailableEquipments] = useState() as any

  const { state } = useContext<any>(
    SurgicalSchedulingContext
  ) as SurgicalScheduleModelContext

  useEffect(() => {
    const dateWithHourStart = state.selectedDate + ' ' + state.selectedHourStart
    const hasSameDate = state.appointments?.some(
      (appointment: AppointmentModel) => {
        return (
          moment.utc(appointment.start_date).format('YYYY-MM-DD HH:mm') ===
          dateWithHourStart
        )
      }
    )

    if (hasSameDate) {
      setShowFinishModal(true)
    } else {
      setShowDivergencyModal(true)
    }
  }, [])

  return (
    <>
      {divergencyModal && (
        <DivergencyModal
          setShowFinishModal={setShowFinishModal}
          setShowModalEvent={setShowModalEvent}
          setShowDivergencyModal={setShowDivergencyModal}
        />
      )}

      {showFinishModal && (
        <FinishScheduleModal
          setShowFinishModal={setShowFinishModal}
          setShowModalEvent={setShowModalEvent}
          setUnavailableEquipments={setUnavailableEquipments}
          setShowUnavailableEquipmentModal={setShowUnavailableEquipmentModal}
          setShowDivergencyModal={setShowDivergencyModal}
        />
      )}

      {showUnavailableEquipmentModal && (
        <UnavailableEquipmentModal
          setShowUnavailableEquipmentModal={setShowUnavailableEquipmentModal}
          showUnavailableEquipmentModal={showUnavailableEquipmentModal}
          setShowModalEvent={setShowModalEvent}
          setShowFinishModal={setShowFinishModal}
          setShowDivergencyModal={setShowDivergencyModal}
          unavailableEquipments={unavailableEquipments}
        />
      )}
    </>
  )
}

const ModalContent = ({
  timeStatus,
  setShowModalEvent,
  showModalEvent,
  selectedEvent
}: any) => {
  const surgicalScheduleService = useServices().surgicalSchedule
  const [isLoading, setIsLoading] = useState(false)
  const [schedule, setSchedule] = useState({}) as any

  const { state } = useContext<any>(
    SurgicalSchedulingContext
  ) as SurgicalScheduleModelContext

  async function getSchedule() {
    try {
      setIsLoading(true)

      if (selectedEvent.schedule_id) {
        const response = await surgicalScheduleService.loadSurgicalSchedule({
          scheduling_id: selectedEvent.schedule_id
        })
        setSchedule(response.data)
      } else {
        const response = await surgicalScheduleService.loadSurgicalSchedule({
          surgical_order_id: selectedEvent.surgical_order_id
        })
        setSchedule(response.data)
      }

      setIsLoading(false)
    } catch (error) {
      toast.error('Falha ao buscar informações da solicitação')
      setIsLoading(false)
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    if (
      timeStatus === TimeStatus.REQUESTED ||
      timeStatus === TimeStatus.SCHEDULED
    )
      getSchedule()
  }, [selectedEvent])

  function getTitle() {
    if (timeStatus === TimeStatus.INTERDICTED) {
      return 'Sala fechada/Interdidada'
    }
    if (timeStatus === TimeStatus.PREPARATION) {
      return 'Preparação'
    }
    if (timeStatus === TimeStatus.RESERVED) {
      return 'Reserva'
    }
    if (timeStatus === TimeStatus.REQUESTED) {
      return 'Detalhes da cirurgia'
    }
    if (timeStatus === TimeStatus.SCHEDULED) {
      return 'Detalhes da cirurgia'
    }
    if (timeStatus === TimeStatus.OPEN) {
      return 'Agendar cirurgia'
    }
  }

  function getContent() {
    if (timeStatus === TimeStatus.PREPARATION) {
      return <PreparationContent />
    }

    if (timeStatus === TimeStatus.INTERDICTED) {
      return <InterdictedContent />
    }

    if (timeStatus === TimeStatus.PREPARATION) {
      return <ReservedContent />
    }

    if (timeStatus === TimeStatus.SCHEDULED) {
      return <ScheduledContent schedule={schedule} />
    }

    if (
      timeStatus === TimeStatus.REQUESTED &&
      state.id !== selectedEvent?.schedule_id
    ) {
      return <RequestedContent schedule={schedule} isLoading={isLoading} />
    }

    if (
      timeStatus === TimeStatus.OPEN ||
      state.id === selectedEvent?.schedule_id
    ) {
      return <OpenSlotContent setShowModalEvent={setShowModalEvent} />
    }
  }
  return (
    <>
      {isLoading ? (
        <LoadingModal show={true} />
      ) : (
        <Modal
          style={{ display: 'block', width: 'auto', padding: 20 }}
          show={showModalEvent}
          close={() => setShowModalEvent(false)}
          preventAutomateClose
        >
          <S.ModalInfo>
            <S.HeaderModal>
              <S.Title>{getTitle()}</S.Title>
              <CloseIcon onClick={() => setShowModalEvent(false)} />
            </S.HeaderModal>
          </S.ModalInfo>
          <DividerNew marginBottom="5px" marginTop="5px" />
          {getContent()}
        </Modal>
      )}
    </>
  )
}

const ModalEvent = ({
  showModalEvent,
  setShowModalEvent,
  timeStatus,
  selectedEvent
}: any) => {
  return (
    <ModalContent
      timeStatus={timeStatus}
      setShowModalEvent={setShowModalEvent}
      showModalEvent={showModalEvent}
      selectedEvent={selectedEvent}
    />
  )
}

const CalendarTests = ({
  searchDate,
  numberOfRooms,
  schedules,
  surgeryCenterName,
  requestedTime
}: any) => {
  // const [searchDate, setSearchDate] = useState(propSearchDate)
  // const [numberOfRooms, setNumberOfRooms] = useState(propNumberOfRooms)
  //const searchDate = '2023-03-06' // Data(dia) da busca do calendário (dia único)
  //const numberOfRooms = 7 // Quantidade de salas que vem da busca

  const { state, dispatch } = useContext<any>(
    SurgicalSchedulingContext
  ) as SurgicalScheduleModelContext

  const roomNames = state.surgical_center_schedule.rooms.map((room) => {
    return room.name
  })

  const [timeStatus, setTimeStatus] = useState('') as any
  const [showModalEvent, setShowModalEvent] = useState(false)
  const [selectedEvent, setSelectedEvent] = useState() as any
  const selectedWeekDate = moment(searchDate).format('LLLL').split('às')[0]
  const formatedWeekDate =
    selectedWeekDate.charAt(0).toUpperCase() + selectedWeekDate.slice(1)

  const numberOfRoomsDate = moment(searchDate)
    .add(numberOfRooms - 1, 'days')
    .toDate()

  const listRooms: ListRooms[] = []

  for (let index = 0; index < numberOfRooms; index++) {
    listRooms[index] = {
      number: index + 1,
      dateReference: moment(searchDate).add(index, 'days').toDate(), // calendar reference date(week day = number of rooms)
      roomName: roomNames[index]
    }
  }

  const renderHeaderContent = (eventInfo: any) => {
    const room = listRooms.find(
      (room) =>
        moment(room.dateReference).format('DD/MM/YYYY') ===
        moment(eventInfo.date).format('DD/MM/YYYY')
    )

    if (room?.number) {
      return `Sala ${room?.roomName}`
    }

    return ''
  }

  // const renderSlotLabelInterval = (eventInfo: any) => {
  //   console.log(eventInfo)
  //   return moment(eventInfo.date).format('H[h]mm')
  // }

  const renderEventContent = (eventInfo: any) => {
    const timeStatus = eventInfo.event.extendedProps?.timeStatus as TimeStatus
    const subtitle = eventInfo.event.extendedProps?.subtitle
    const selectedRequest =
      state.id === eventInfo.event.extendedProps.schedule_id

    return (
      <S.CardEvent timeStatus={timeStatus} selectedRequest={selectedRequest}>
        <S.CardTitle selectedRequest={selectedRequest}>
          {eventInfo.event.title}
        </S.CardTitle>
        {subtitle && <S.CardSubtitle>{subtitle}</S.CardSubtitle>}
        {timeStatus !== TimeStatus.PREPARATION &&
          timeStatus !== TimeStatus.OPEN && (
            <S.CardTimeText selectedRequest={selectedRequest}>
              {`${moment(eventInfo.event.start).format('H[h]mm')} -
              ${moment(eventInfo.event.end).format('H[h]mm')}`}
            </S.CardTimeText>
          )}
      </S.CardEvent>
    )
  }

  const handleEventClick = (eventInfo: any) => {
    const formatedRequestedTime = moment.duration(requestedTime).asHours()

    const preparationTime = moment(
      eventInfo.event.extendedProps.preparation_time
    ).format('mm')
    const selectedDate = moment(eventInfo.event.start).format(
      'YYYY-MM-DD HH:mm'
    )

    const schedulesOfDay = schedules.filter((item: any) => {
      return (
        moment(item.start).format('YYYY-MM-DD') ===
          moment(selectedDate).format('YYYY-MM-DD') && item.title !== null
      )
    })

    const selectedAvailableDate = {
      start: moment(eventInfo.event.start).format('YYYY-MM-DD HH:mm'),

      endWithPreparation: moment(eventInfo.event.start)
        .add(formatedRequestedTime, 'hours')
        .add(preparationTime, 'minutes')
        .format('YYYY-MM-DD HH:mm'),

      end: moment(eventInfo.event.start)
        .add(formatedRequestedTime, 'hours')
        .format('YYYY-MM-DD HH:mm')
    }

    dispatch({
      type: 'SELECTED_ROOM_ID',
      payload: eventInfo.event.extendedProps.selectedRoomId
    })

    const selectedHourStart = moment(selectedAvailableDate.start).format(
      'HH:mm'
    )

    dispatch({ type: 'SELECTED_HOUR_START', payload: selectedHourStart })

    const selectedHourEndWithPreparation = moment(
      selectedAvailableDate.endWithPreparation
    ).format('HH:mm')
    dispatch({
      type: 'SELECTED_HOUR_END_WITH_PREPARATION',
      payload: selectedHourEndWithPreparation
    })

    const selectedHourEnd = moment(selectedAvailableDate.end).format('HH:mm')
    dispatch({ type: 'SELECTED_HOUR_END', payload: selectedHourEnd })

    const isUnavailable = schedulesOfDay.some((item: any) => {
      return (
        (moment(selectedAvailableDate.endWithPreparation).isBetween(
          item.start,
          item.end
        ) &&
          item.extendedProps.timeStatus !== 'requested') ||
        (moment(selectedAvailableDate.start).isBefore(item.start) &&
          moment(selectedAvailableDate.endWithPreparation).isAfter(
            item.start
          ) &&
          item.extendedProps.timeStatus !== 'requested')
      )
    })

    if (
      state.selectedDate === moment(new Date()).format('yyyy-MM-DD') &&
      selectedHourStart < moment(new Date()).format('HH:mm') &&
      eventInfo.event.extendedProps.timeStatus === 'open'
    ) {
      toast.error('Esta data já está indisponível')
      return
    }

    if (isUnavailable && eventInfo.event.extendedProps.timeStatus === 'open') {
      return toast.error(
        'Duração da cirurgia não compatível com disponibilidade da sala.'
      )
    }

    setShowModalEvent(true)
    setTimeStatus(eventInfo.event.extendedProps.timeStatus)
    setSelectedEvent(eventInfo.event.extendedProps)
  }

  const handleValidRange = () => {
    const numberOfRoomsDateIncrement = moment(numberOfRoomsDate)
      .add(1, 'days')
      .toDate()

    return {
      start: searchDate,
      end: numberOfRoomsDateIncrement
    }
  }

  // function getTimeGridSize() {
  //   if (numberOfRooms <= 7) {
  //     return 'timeGrid'
  //   } else {
  //     return 'timeGrid,timeGridMax'
  //   }
  // }

  return (
    <>
      <div>
        <S.DateTitle>
          <SupportTextNew weight="bold" color="neutral700">
            {formatedWeekDate}
          </SupportTextNew>
          {/* <MaximizeIcon /> */}
        </S.DateTitle>
        <DividerNew marginTop="8px" />
        <CardNew shadow="none" background="neutral50" padding="8px">
          <SupportTextNew
            color="neutral700"
            size="medium"
            weight="semiBold"
            capitalize
            style={{ textAlign: 'center' }}
          >
            {surgeryCenterName.toLowerCase()}
          </SupportTextNew>
        </CardNew>
      </div>
      <FullCalendar
        nowIndicator={false}
        plugins={[timeGridPlugin, momentPlugin, momentTimezonePlugin]}
        initialView="timeGrid"
        headerToolbar={{
          start: '',
          center: '', //getTimeGridSize(),
          end: 'prev,next'
        }}
        // views={{
        //   timeGrid: {
        //     type: 'timeGrid',
        //     dayCount: numberOfRooms,
        //     buttonText: numberOfRooms <= 7 && `${numberOfRooms} salas`
        //   },
        //   timeGridMax: {
        //     type: 'timeGrid',
        //     dayCount: numberOfRooms,
        //     buttonText: `${numberOfRooms} salas`
        //   }
        // }}
        // titleFormat="dddd, D [de] MMMM [de] YYYY"
        initialDate={searchDate}
        validRange={handleValidRange}
        duration={{
          days: 6
        }}
        weekends={true}
        dayHeaders={true}
        dayHeaderContent={renderHeaderContent}
        allDaySlot={false}
        slotDuration="00:30"
        slotLabelInterval="01:00"
        slotLabelFormat="H[h]mm"
        // slotLabelContent={renderSlotLabelInterval}
        slotMinTime="05:00"
        slotMaxTime="23:01"
        scrollTimeReset={true}
        events={schedules}
        eventContent={renderEventContent}
        eventClick={handleEventClick}
        locale="pt-br"
        timeZone="America/Sao_Paulo"
        eventClassNames="calendar-event-box"
        dayHeaderClassNames="calendar-day-header"
        dayCellClassNames="calendar-day-cell"
        eventBackgroundColor="transparent"
        eventBorderColor="transparent"
      />
      <ModalEvent
        showModalEvent={showModalEvent}
        setShowModalEvent={setShowModalEvent}
        selectedEvent={selectedEvent}
        timeStatus={timeStatus}
      />
    </>
  )
}

export default CalendarTests
